import { useSelector } from "react-redux";
import { formOpenSelector, setFormOpen } from "../../reducers/rhapsody";
import { RhapsodyProUpgrade } from "../rhapsodyProUpgrade/rhapsodyProUpgrade";
import { DeleteMyAccount } from "../deleteMyAccount/deleteMyAccount";
import { AccountCredentials } from "../accountCredentials/accountCredentials";
import { ChangePassword } from "../changePassword/changePassword";
import { Passkeys } from "../passkeys/passkeys";
import { SmsNotifications } from "../smsNotifications/smsNotifications";
import { WeeksStartOn } from "../weeksStartOn/weeksStartOn";
import { FormGig } from "../FormGig/FormGig";
import { FormVenue } from "../FormVenue/FormVenue";
import { FormSeason } from "../FormSeason/FormSeason";
import { FormProject } from "../FormProject/FormProject";
import { FormContractor } from "../FormContractor/FormContractor";
import {
  Chip,
  List,
  ListItemButton,
  ListItemContent,
  ListItemDecorator,
  Typography,
  useTheme,
} from "@mui/joy";
import React from "react";
import { Grid, Popover, useMediaQuery } from "@mui/material";
import { useDispatch } from "react-redux";
import { usePro } from "../usePro/usePro";
import { proEnabled } from "../../constants";

/**
 *
 * @returns {ReactElement} CreateCenter page
 */
export function CreateCenter() {
  const dispatch = useDispatch();
  const upgradeOpen = useSelector(formOpenSelector("upgradeOpen"));
  const deleteMyAccountOpen = useSelector(formOpenSelector("deleteMyAccount"));
  const accountCredentialsOpen = useSelector(
    formOpenSelector("accountCredentials")
  );
  const smsNotificationsOpen = useSelector(
    formOpenSelector("smsNotifications")
  );
  const changePassword = useSelector(formOpenSelector("changePassword"));
  const passkeysOpen = useSelector(formOpenSelector("passkeys"));
  const weeksStartOn = useSelector(formOpenSelector("weeksStartOn"));
  const gigOpen = useSelector(formOpenSelector("gig"));
  const venueOpen = useSelector(formOpenSelector("venue"));
  const projectOpen = useSelector(formOpenSelector("project"));
  const seasonOpen = useSelector(formOpenSelector("season"));
  const contractorOpen = useSelector(formOpenSelector("contractor"));
  const [anchorEl, setAnchorEl] = React.useState(null);
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down("sm"));
  const pro = usePro();
  return (
    <>
      {proEnabled ? (
        <Chip
          data-tut="reactour__create"
          size="sm"
          color="info"
          endDecorator={<i className="far fa-plus-circle"></i>}
          onClick={(e) => {
            setAnchorEl(e.currentTarget);
          }}
        >
          {!sm ? "Create" : ""}
        </Chip>
      ) : (
        []
      )}
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <Grid container style={{ padding: 13, width: 340 }}>
          <Grid item xs={12}>
            <Typography level="h6">Create</Typography>
          </Grid>
          <List>
            <ListItemButton
              onClick={() => {
                setAnchorEl(null);
                dispatch(setFormOpen({ isOpen: true, formID: "gig" }));
              }}
            >
              <ListItemDecorator>
                <i className="fa-regular fa-violin"></i>
              </ListItemDecorator>
              <ListItemContent>
                <Typography>Service</Typography>
                <Typography level="body3">A date you play</Typography>
              </ListItemContent>
            </ListItemButton>
            <ListItemButton
              onClick={() => {
                setAnchorEl(null);
                dispatch(setFormOpen({ isOpen: true, formID: "project" }));
              }}
            >
              <ListItemDecorator>
                <i className="fa-regular fa-folder"></i>
              </ListItemDecorator>
              <ListItemContent>
                <Typography>Project</Typography>
                <Typography level="body3">A group of Services</Typography>
              </ListItemContent>
            </ListItemButton>
            <ListItemButton
              onClick={() => {
                setAnchorEl(null);
                dispatch(setFormOpen({ isOpen: true, formID: "season" }));
              }}
            >
              <ListItemDecorator>
                <i className="fa-regular fa-ticket"></i>
              </ListItemDecorator>
              <ListItemContent>
                <Typography>Season</Typography>
                <Typography level="body3">A group of Projects</Typography>
              </ListItemContent>
            </ListItemButton>
            <ListItemButton
              onClick={() => {
                setAnchorEl(null);
                dispatch(setFormOpen({ isOpen: true, formID: "venue" }));
              }}
            >
              <ListItemDecorator>
                <i className="fa-regular fa-map-pin"></i>
              </ListItemDecorator>
              <ListItemContent>
                <Typography>Venue</Typography>
                <Typography level="body3">A place where you perform</Typography>
              </ListItemContent>
            </ListItemButton>
            <ListItemButton
              onClick={() => {
                setAnchorEl(null);
                dispatch(setFormOpen({ isOpen: true, formID: "contractor" }));
              }}
            >
              <ListItemDecorator>
                <i className="fa-regular fa-user-music"></i>
              </ListItemDecorator>
              <ListItemContent>
                <Typography>Organization</Typography>
                <Typography level="body3">An entity hiring you</Typography>
              </ListItemContent>
            </ListItemButton>
          </List>
        </Grid>
      </Popover>
      {upgradeOpen ? <RhapsodyProUpgrade /> : []}
      {deleteMyAccountOpen ? <DeleteMyAccount /> : []}
      {accountCredentialsOpen ? <AccountCredentials /> : []}
      {changePassword ? <ChangePassword /> : []}
      {passkeysOpen ? <Passkeys /> : []}
      {smsNotificationsOpen ? <SmsNotifications /> : []}
      {weeksStartOn ? <WeeksStartOn /> : []}
      {gigOpen ? <FormGig /> : []}
      {venueOpen ? <FormVenue /> : []}
      {projectOpen ? <FormProject /> : []}
      {seasonOpen ? <FormSeason /> : []}
      {contractorOpen ? <FormContractor /> : []}
    </>
  );
}
